import { PAYER_TYPES, PAYMENT_METHODS } from "constants/payments";
import { Sale } from "services/types/sales.type";
import { formatBackendDateOnly, formatMoney } from "utils/common";

export const getPaymentsTableHtml = (sale: Sale) => {
  let result = `<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 19.9864%;"><col style="width: 19.9864%;"><col style="width: 19.9864%;"><col style="width: 19.9864%;"><col style="width: 19.9864%;"></colgroup>
  <tbody>
    <tr>
      <td><strong>Date</strong></td>
      <td><strong>Payment By</strong></td>
      <td><strong>Description</strong></td>
      <td><strong>Payment Method</strong></td>
      <td><strong>Amount</strong></td>
    </tr>`;

  sale?.payments?.forEach((payment) => {
    let row = `<td>${formatBackendDateOnly(
      payment.payment_date,
      "MMMM dd, yyyy"
    )}</td>`;

    row = row + `<td>${PAYER_TYPES.getFromCode(payment.payer_type)}</td>`;

    row = row + `<td>${payment.description ?? ""}</td>`;
    row = row + `<td>${PAYMENT_METHODS.getFromCode(payment.method)}</td>`;
    row =
      row +
      `<td style="text-align: right">${formatMoney(
        Number(payment.amount),
        2
      )}</td>`;

    result = result + "<tr>" + row + "</tr>";
  });

  result =
    result +
    `<tr style="border: none">
      <td colspan="5"><br></td>
    </tr>`;

  result =
    result +
    `<tr style="border: none">
      <td colspan="3"><br></td>
      <td style="font-weight: 700">Payments Total</td>
      <td style="font-weight: 700;text-align: right">${formatMoney(
        Number(sale.total_paid)
      )}</td>
    </tr>`;

  result = result + `</tbody></table>`;
  return result;
};
